export default "__VITE_ASSET__udEZTjVG__"